import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import Image from '@jetshop/ui/Image';
import { transparentDataImg } from '@jetshop/ui/Image/Image';
import { isDateString } from './helpers';

const ItemWrapper = styled('div')`
  position: relative;
  color: inherit;
  display: flex;
  flex-wrap: wrap;
  align-self: stretch;
  align-items: flex-start;
  flex-flow: column;
  text-align: center;
  > a {
    width: 100%;
    display: block;
  }
  .item-image {
    padding: 0;
    width: 100%;
    .item-image-container {
      //padding-top: 55%;
      //background-size: cover;
    }
    img {
      max-width: 100%;
    }
  }
  .item-text {
    padding: 15px 0 30px;
    overflow: hidden;
    width: 100%;
  }
  .parent-name {
    margin-bottom: 0.5rem;
    h5 {
      text-transform: none;
    }
  }
  .item-name {
    h4 {
      text-transform: none;
    }
    a {
      text-decoration: none;
    }
  }
  .item-content {
    margin-top: 0.5rem;
    max-height: 113px;
    overflow: hidden;
    img {
      display: none !important;
    }
    p {
      font-weight: 100;
      font-size: 0.87rem;
    }
  }
`;

const BlogItem = ({ category, index, className, showReadMore = false }) => {
  const getSizes = index => {
    let sizes = [1 / 2, 1 / 2, 1 / 2, 1 / 2];
    /*if (index === 0) {
      sizes = [1, 1, 1, 1200];
    }*/
    return sizes;
  };
  return (
    <ItemWrapper className={`blog-item ${className}`}>
      <CategoryLink category={category}>
        <div className="item-image">
          {category.images?.length ? (
            <Image
              className="item-image-container"
              src={category.images}
              alt={category.name}
              sizes={getSizes(index)}
              aspect={'5:3'}
              crop={true}
              cover
            />
          ) : (
            <Image src={transparentDataImg} aspect={'5:3'} />
          )}
        </div>
        <div className="item-text">
          {category.parent && (
            <div className="parent-name">
              <h5>{category.parent.name}</h5>
            </div>
          )}
          <div className="item-name">
            <h3>{category.name}</h3>
          </div>
          {isDateString(category.mainHeader) && (
            <div className="item-date">
              <h5>{category.mainHeader}</h5>
            </div>
          )}
          {category.head &&
            category.head.metaTags &&
            category.head.metaTags.length > 0 && (
              <div className="item-content">
                <p
                  dangerouslySetInnerHTML={{
                    __html: category.head.metaTags[0].content
                  }}
                />
              </div>
            )}
        </div>
      </CategoryLink>
    </ItemWrapper>
  );
};

export default BlogItem;
